module.exports = __webpack_public_path__ + "static/autobus-carre-64100951a7f3f2d8e153216485f088bb.png";